import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, Image, AvailableLabel } from 'newComponents'
import './styles.scss'

const FeatureList = (props) => {
  const { data } = props
  const { primary, items } = data
  const { content, title, unordered_list: list, background } = primary
  // content checks
  const titleHtml = title?.html
  const contentHtml = content?.html
  const listHtml = list?.html
  const backgroundColor = background === 'White' || !background ? 'white' : 'dark-blue'

  return (
    <OnVisible className={`feature-list ${backgroundColor}`}>
      <Section>
        <div className="feature-list-text">
          {titleHtml && <div className="feature-list-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
          <div className="feature-list-text-content">
            {contentHtml && <div className="feature-list-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />}
            {listHtml && <div className="feature-list-list" dangerouslySetInnerHTML={{ __html: listHtml }} />}
          </div>
        </div>
        <div className="feature-list-features">
          {items.map((item) => {
            const { feature_decription: description, feature_icon: icon, feature_title: featureTitle, badge } = item
            const descriptionHtml = description?.html
            const fTitleHtml = featureTitle?.html
            const hasIcon = icon?.url || icon?.localFile

            return (
              <div className="feature-list-feautre" key={featureTitle.text}>
                {hasIcon && <Image className="feature-list-feautre-image" image={icon} />}
                <div className="feature-list-feature-title-label">
                  {fTitleHtml && (
                    <div className="feature-list-feature-title" dangerouslySetInnerHTML={{ __html: fTitleHtml }} />
                  )}
                  <AvailableLabel badge={badge} />
                </div>
                {descriptionHtml && (
                  <div className="feature-list-feature-title" dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
                )}
              </div>
            )
          })}
        </div>
      </Section>
    </OnVisible>
  )
}

export default FeatureList
